import { faDollar } from '@fortawesome/pro-regular-svg-icons';
import { PricingGuide } from './pricingGuide/PricingGuide';
import { Typography } from '@design-system/components/typography/typography';
import { Button } from '@design-system/components/button/button';
import { usePricingModel } from './pricing.model';
import { AsyncRenderer } from '@client/new/components/AsyncRenderer/AsyncRenderer';
import { InputPrice } from '@design-system/components/input/inputPrice';
import { Collection } from '../collection.domain';
import { Link } from 'react-router';
import { PATHS } from '@client/routes';
import { Chip } from '@design-system/components/chip/chip';
import { sprinkles } from '@design-system/sprinkles.css';
import { Alert } from '@design-system/components/alert/alert';
import * as styles from './ProgramPricing.css';

type ProgramPricingProps = {
  creatorId: number;
  collection: Collection;
};

export const ProgramPricing = ({
  creatorId,
  collection,
}: ProgramPricingProps) => {
  const model = usePricingModel({ creatorId, collection });

  return (
    <AsyncRenderer
      data={model}
      renderer={(data) => (
        <div className={styles.container}>
          <Alert
            variant="info"
            details="To sell this product or change its price go to Offers"
            allowClose
            wrapperClassName={styles.banner}
          />

          <div className={styles.card}>
            <div className={styles.cardHeader}>
              <Typography variant="body" size="large">
                Offers
              </Typography>
              <Link to={PATHS.BUNDLES(data.creatorId)}>
                <Button
                  color="primary"
                  variant="text"
                  className={styles.offersButton}
                >
                  Go to Offers
                </Button>
              </Link>
            </div>
            {data.offers.length > 0 && (
              <>
                <Typography
                  variant="body"
                  size="medium"
                  fontWeight="normal"
                  color="N-80"
                >
                  This program belongs to:
                </Typography>
                <div className={styles.chips}>
                  {data.offers.map(({ id, title, bgColor, opacity }) => (
                    <Chip
                      key={id}
                      readonly={true}
                      label={title}
                      className={sprinkles({
                        bg: { hover: bgColor, lightMode: bgColor },
                        opacity,
                      })}
                    />
                  ))}
                </div>
              </>
            )}
          </div>

          {data.currentPrice !== null && (
            <div className={styles.card}>
              <Typography variant="body" size="medium" fontWeight="normal">
                To change its price you need to create a new OTP Offer
              </Typography>
              <InputPrice
                label="Price"
                required
                disabled
                value={data.currentPrice / 100}
                onChange={() => undefined}
                startIcon={{ icon: faDollar }}
                wrapperClassName="lg:w-[150px]"
              />
              <PricingGuide disabled />
            </div>
          )}
        </div>
      )}
    />
  );
};
